'use strict';

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var settings = require('../../utilities/settings').default;

var ButtonsView = require('../buttons/buttons').default;
var BackButtonView = require('../buttons/back').default;
var NextButtonView = require('../buttons/next').default;
var BookButtonView = require('../buttons/book').default;
var UpdateButtonView = require('../buttons/update').default;

export default Marionette.View.extend({

  tagName: 'footer',
  attributes: {
    id: 'footer',
    class: 'l-footer',
    role: 'contentinfo',
  },
  template: require('./templates/footer.hbs'),
  regions: {
    buttons: '.l-footer-buttons',
  },
  ui: {
    copyright: '.l-footer-support-and-copyright',
  },

  onRender: function () {
    if (settings.inIFrame() || window.SETTINGS.private_label) {
      this.hideWrapper();
    }

    this.getRegion('buttons').show(new ButtonsView({
      left: new BackButtonView(),
      right: new NextButtonView(),
      book: new BookButtonView(),
      update: new UpdateButtonView(),
    }));
  },

  hideWrapper: function () {
    this.ui.copyright.remove();
  },

});
